<template>
  <div v-if="intent">
    <v-layout style="border-bottom: 1px solid #eee;" class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{ errors.first('intentName') }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>
    <div>
      <v-layout wrap>
        <v-flex xs12 class="pa-2" v-if="intent.type == 'start_node'">
          <v-layout>
            <v-flex class="small">{{ $t('Incoming User Input') }}</v-flex>
            <v-flex class="text-xs-right">
              <AddSuggestUserInput @handleAddSugguestion="handleAddSugguestion" />
            </v-flex>
          </v-layout>
          <div
            class="form-control"
            :class="{ 'has-error': errorTag.length > 0 || errors.has('intentQuestion') }"
          >
            <tags
              v-model="reply"
              :tags="replies"
              @tags-changed="addReplies"
              @before-adding-tag="checkQuickReply"
              style="margin-bottom: 5px;"
              :btnText="$t('Add user input')"
            ></tags>
            <span class="text-error" v-show="errors.has('intentQuestion')">
              {{ errors.first('intentQuestion') }}
            </span>
            <span class="text-error" v-if="errorTag.length > 0">
              <template v-if="errorTag.includes('overmaxlength')">
                {{ $t('Message cannot be longer than 20 alphabets') }}
              </template>
              <template v-else-if="errorTag.includes('overtagmax')">
                {{ $t('Choices cannot be more than 10 items') }}
              </template>
              <template v-else-if="errorTag.includes('duplicate')">
                {{ $t('Duplicate Choice') }}
              </template>
            </span>
          </div>

          <input
            type="hidden"
            v-model="intent.question"
            v-validate="'required'"
            name="intentQuestion"
            :data-vv-as="$t('Incoming User Input')"
          />
        </v-flex>
        <v-flex xs12 class="pa-2">
          <intent-manage-answers v-model="intent.answer"></intent-manage-answers>
        </v-flex>
        <v-flex xs12 class="pa-2">
          <div class="hr"></div>
          <p class="small" style="margin-top: 10px;">{{ $t('Choice') }}</p>

          <div class="form-control" :class="{ 'has-error': errorChoice.length > 0 }">
            <tags
              v-model="choice"
              :tags="choices"
              @tags-changed="addChoices"
              @before-adding-tag="checkChoices"
              style="margin-bottom: 5px;"
              :btnText="$t('Add choice')"
            ></tags>
            <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
            <span class="text-error" v-if="errorChoice.length > 0">
              <template v-if="errorChoice.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorChoice.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorChoice.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
          </div>
        </v-flex>
      </v-layout>

      <slot name="footer" :onSave="onSave" :onCancel="onCancel">
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import IntentManageAnswers from './IntentManageAnswers'
import AddSuggestUserInput from './AddSuggestUserInput.vue'
export default {
  props: ['value'],
  data() {
    return {
      intent: null,
      excludedName: '',
      reply: '',
      choice: '',
      errorTag: [],
      errorChoice: []
    }
  },
  components: {
    Tags,
    IntentManageAnswers,
    AddSuggestUserInput
  },
  mounted() {
    this.intent = JSON.parse(JSON.stringify(this.value))
    this.cached_intent = JSON.stringify(this.intent)
  },
  computed: {
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.question && vm.intent.question.input !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          quick_replies = vm.intent.question.split(',')
          var result = []
          $.each(quick_replies, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.$set(vm.intent, 'question', result.join(','))
      }
    },
    choices: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          $.each(quick_replies, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.intent.quick_reply = result.join(',')
      }
    }
  },
  methods: {
    handleAddSugguestion(val) {
      const value = `{${val}}`
      if (!this.replies.some(reply => reply.text == value)) {
        this.replies.push({ text: value })
      }
    },
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('onCancel')
    },
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }
        this.cached_intent = JSON.stringify(this.intent)
        this.$emit('onSave', this.intent)
      })
    },
    addReplies(newTags) {
      this.replies = newTags
    },
    addChoices(newTags) {
      this.choices = newTags
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkChoices(obj) {
      this.errorChoice = []
      if (obj.tag.text.length > 20) {
        this.errorChoice.push('overmaxlength')
        obj.error()
      } else if (this.replies.length >= 10) {
        this.errorChoice.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorChoice.push('duplicate')
        obj.error()
      } else obj.addTag()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/IntentManage.vue